import React, { useState } from "react";
import { Button, Menu, MenuItem, ListItemText } from "@mui/material";
import { ArrowUpward, ArrowDownward, SwapVert, Check } from "@mui/icons-material";

// Compact "Sort by" control for card-list mobile layouts, standing in for the
// SortableHeader column clicks that only exist in the desktop table.
export function MobileSortControl({ tableType, options, currentConfig, handleSort }) {
  const [anchor, setAnchor] = useState(null);
  const activeOption = options.find((o) => o.value === currentConfig?.key);

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={
          currentConfig?.direction === 'desc' ? <ArrowDownward fontSize="small" /> : <ArrowUpward fontSize="small" />
        }
        endIcon={<SwapVert fontSize="small" />}
        onClick={(e) => setAnchor(e.currentTarget)}
        sx={{ mb: 1.5 }}
      >
        Sort: {activeOption?.label || 'Default'}
      </Button>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {options.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === currentConfig?.key}
            onClick={() => {
              handleSort(tableType, option.value);
              setAnchor(null);
            }}
          >
            {option.value === currentConfig?.key && (
              <Check fontSize="small" sx={{ mr: 1 }} />
            )}
            <ListItemText inset={option.value !== currentConfig?.key}>
              {option.label}
              {option.value === currentConfig?.key && (currentConfig.direction === 'desc' ? ' (desc)' : ' (asc)')}
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default MobileSortControl;
